import React from "react"

import { cn } from "@/domains/library"
import { SortIcon } from "@/domains/liquidity-page/sort-icon"
import type { Sort } from "@/domains/table-processor"

export const DisplaySortIcon = ({ sortBy, column }: { sortBy: Sort; column: string }) => {
  // not true, sortBy is sometimes undefined - we program defensively, typescript doesn't know that
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!sortBy) {
    return null
  }
  if (!(column === sortBy.key)) {
    return null
  }
  return <SortIcon direction={sortBy.direction} className="mt-[2px] h-[15px] min-h-[15px] w-[15px] min-w-[15px]" />
}

export const SortableTableHeader = React.forwardRef<
  HTMLTableHeaderCellElement,
  React.ThHTMLAttributes<HTMLTableHeaderCellElement> & { sortBy: Sort; sortColumn: string; classNameInner?: string }
>(({ className, sortBy, sortColumn, classNameInner, children, ...props }, ref) => {
  return (
    <th ref={ref} className={cn("cursor-pointer content-start px-2 py-2 font-medium sm:px-4", className)} {...props}>
      <div className={cn("flex items-start gap-1", classNameInner)}>
        {children}
        <DisplaySortIcon sortBy={sortBy} column={sortColumn} />
      </div>
    </th>
  )
})

SortableTableHeader.displayName = "SortableTableHeader"

